import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Accordion, Row, Card, Spinner } from "react-bootstrap";
import _ from "lodash";
import ApiAgent from "../../../core/api/api.agent";
import ApiHome from "../../../core/api/api.home";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiBasketItemPerson from "../../../core/api/api.basketItemPerson";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { FormProvider, useForm, Controller } from "react-hook-form";
import ApiUserWallet from "../../../core/api/api.userWallet";
import { useLocation, useNavigate } from "react-router-dom";
import DataGridUsedPromoCodeByUser from "./DataGridUsedPromoCodeByUser";
import SwalMessage from "../_Components/SwalMessage";
import Swal from "sweetalert2";
import { TextField } from "@mui/material";
import { tools } from "../../../core/utils/tools";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import CloseIcon from "@mui/icons-material/Close";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";
import EditCommisionPrice from "./EditCommisionPrice";

const Index = () => {
  let location = useLocation();
  let navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const [agents, setAgents] = useState([]);
  const [checkBoxList2, setCheckBoxList2] = useState([]);
  const [promoCategoryTypes, setPromoCategoryTypes] = useState([]);
  const [commissionSettlementStatus, setCommissionSettlementStatus] = useState([]);
  const [selectedUsedCommision, setSelectedUsedCommision] = useState()
  const [refresh, setRefresh] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const [amusementServiceList, setAmusementServiceList] = useState([]);
  const [group, setGroup] = useState([]);
  const [groupedReserveItemsOptions, setGroupedReserveItemsOptions] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };

  useEffect(() => {
    (async () => {
      try {
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
        const globalSearchFromUrl = searchParams.get("globalSearch");
        const commissionSettlementStatusFromUrl = searchParams.get("commissionSettlementStatus");
        const data = await ApiAgent.getAllUsedPromoCodeByUser({
          promoCode: searchParams.get("promoCode"),
          amusementServiceIds: searchParams.get("amusementServiceIds"),
          amusementServiceReserveItemIds: searchParams.get("amusementServiceReserveItemIds"),
          amusementServiceReserveItemGroupIds: searchParams.get("amusementServiceReserveItemGroupIds"),
          fromCreatedDate: searchParams.get("fromCreatedDate"),
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          globalSearch: !_.isEmpty(globalSearchFromUrl) ? globalSearchFromUrl : location?.state?.promoCodeId,
          toCreatedDate: searchParams.get("toCreatedDate"),
          useTimeOf: searchParams.get("useTimeOf"),
          useTimeTo: searchParams.get("useTimeTo"),
          agentId: searchParams.get("agentId"),
          promoCategoryType: searchParams.get("promoCategoryType"),
          commissionSettlementStatus: !_.isEmpty(commissionSettlementStatusFromUrl) ? commissionSettlementStatusFromUrl : 0,
        });
        setListData(data);
        setValue("totalCount", data.totalCount);

        const agentsResponse = await ApiAgent.getAllAgentsName();
        setAgents(agentsResponse);

        const promoCategoryTypesFromServer = await ApiHome.getEnums({ enumName: "PromoCodePublicationType" });
        if (promoCategoryTypesFromServer.succeeded) {
          setPromoCategoryTypes(promoCategoryTypesFromServer?.data);
        }

        const commissionSettlementStatusFromServer = await ApiHome.getEnums({ enumName: "CommissionSettlementStatus" });

        if (commissionSettlementStatusFromServer.succeeded) {
          const CommissionSettlementArray = commissionSettlementStatusFromServer?.data?.map((item) => ({ value: item.value, label: item.title }))
          setCommissionSettlementStatus([{ value: undefined, label: "-------" }, ...CommissionSettlementArray]);
        }
        setValue("commissionSettlementStatus", { value: 0, label: "در انتظار" });

        const apiData = await ApiAmusementService.getAllServicesWithItems();
        if (!_.isEmpty(apiData)) {
          setAmusementServiceList(apiData);
        }

        const amusementItemIds = searchParams.get("amusementServiceIds")?.split(",") || [];

        const selectedServiceIds = apiData.filter((item) => amusementItemIds.includes(String(item.id)));

        const selectedItemsGroupIds = searchParams.get("amusementServiceReserveItemGroupIds")?.split(",") || [];

        const selectedItemsItemIds = searchParams.get("amusementServiceReserveItemIds")?.split(",") || [];

        inputChangeHandlerService(selectedServiceIds, true, selectedItemsGroupIds, selectedItemsItemIds);

        const formInputs = [
          { name: "promoCode", type: "text" },
          { name: "fromCreatedDate", type: "datePicker" },
          { name: "toCreatedDate", type: "datePicker" },
          { name: "amusementServiceIds", type: "multiSelect", isMulti: true, data: apiData },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
          { name: "useTimeOf", type: "datePicker" },
          { name: "useTimeTo", type: "datePicker" },
          {
            name: "agentId",
            type: "multiSelect",
            isMulti: false,
            data: agentsResponse.map((item) => ({ id: item.id, title: item.companyName })),
          },
          {
            name: "promoCategoryType",
            type: "multiSelect",
            isMulti: false,
            data: promoCategoryTypesFromServer?.data,
          },
          {
            name: "commissionSettlementStatus",
            type: "multiSelect",
            isMulti: false,
            data: commissionSettlementStatusFromServer?.data?.map((item) => ({ id: item.value, title: item.title })),
          },
        ];

        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
        const queryParamsObj = getValues()
        if (queryParamsObj.commissionSettlementStatus) queryParamsObj.commissionSettlementStatus = queryParamsObj.commissionSettlementStatus.value
        var queryString = tools.createQueryStringFromFromData(_.omit(queryParamsObj, ["totalPages", "totalCount"]));
        navigate(`${location.pathname}?${queryString}`);
      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
  }, [refresh]);

  const inputChangeHandlerService = async (event, firstRender = false, selectedItemsGroupIds, selectedItemsItemIds) => {
    !firstRender && setValue("amusementServiceIds", event);
    if (event.length > 0) {
      const intersection = firstRender
        ? event
        : _.intersectionBy(
          amusementServiceList,
          event.map((item) => ({ id: item.value })),
          "id",
        );
      let groupItemOptions = [],
        reserveItemOptions = [],
        itemList = [],
        groupList = [];

      intersection.map((item) => {
        const { amusementServiceReserveItems, amusementServiceReserveItemGroups, id: value, name } = item;
        const label = event.find((item) => item.value == value)?.label;
        const options1 = amusementServiceReserveItems?.map((item) => ({ value: item.id, label: item.title }));
        const options2 = amusementServiceReserveItemGroups?.map((item) => ({ value: item.id, label: item.title }));
        groupItemOptions.push({ label, options: options2 });
        reserveItemOptions.push({ label, options: options1 });

        if (firstRender) {
          const selectedItemIds = amusementServiceReserveItems
            ?.filter((item) => selectedItemsItemIds.includes(String(item.id)))
            ?.map((item) => ({ value: item.id, label: item.title }));
          const selectedItemIdsGroup = amusementServiceReserveItemGroups
            ?.filter((item) => selectedItemsGroupIds.includes(String(item.id)))
            ?.map((item) => ({ value: item.id, label: item.title }));
          itemList.push(...selectedItemIds);
          groupList.push(...selectedItemIdsGroup);
        }
      });

      setGroupedReserveItemsOptions(reserveItemOptions);
      setGroup(groupItemOptions);

      if (firstRender) {
        setValue("amusementServiceReserveItemIds", itemList);
        setValue("amusementServiceReserveItemGroupIds", groupList);
      }
    } else if (event.length === 0) {
      setGroupedReserveItemsOptions([]);
      setGroup([]);
      setValue("amusementServiceReserveItemGroupIds", []);
      setValue("amusementServiceReserveItemIds", []);
    }
  };

  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);
  };

  async function handleGroupEdit(type) {
    if (!_.isEmpty(checkBoxList2)) {
      var listId = [];
      checkBoxList2.map((item) => {
        listId.push(item.id);
      });

      let resp;
      setLoadingSubmit(true);
      try {
        switch (type) {
          case 1:
            resp = await ApiUserWallet.incRiallBalanceForCommisonAgent({ listBIPId: listId });
            break;
          case 2:
            resp = await ApiUserWallet.decRiallBalanceForCommisonAgent({ listBIPId: listId });
            break;
          case 3:
            resp = await ApiBasketItemPerson.updateStatusAgentCommission({ basketItemPersonIds: listId });
            break;
        }

        if (type === 3) {
          SwalMessage({ title: resp.message, iSsuccess: resp.succeeded, timer: 10000 });
          setLoadingSubmit(false);
          return;
        }

        // here the type is 1 or 2
        if (type !== 3) { // here the reponse.data is null or Array of messages
          if (resp.data !== null) {
            let HtmlOutPut = resp.data?.map((item) => {
              return (
                "<p class='text-md-center ml-6 ml-md-0 my-1'><span>شماره بلیط: " +
                item.data +
                " </span><span class='" +
                (item.succeeded == true ? "text-success " : "text-danger") +
                "'> تسویه : " +
                (item.succeeded == true ? "انجام شد" : "انجام نشد") +
                " </span><span> پیغام سیستم : " +
                item.message +
                "</span></p>"
              );
            });

            const swalWithBootstrapButtons = Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md mr-2  ",
                cancelButton: "btn btn-danger  btn-md ml-2 ",
              },
              buttonsStyling: false,
            });

            swalWithBootstrapButtons.fire({
              icon: "info",
              title: "نتیجه عملیات",
              html: HtmlOutPut,
              showConfirmButton: false,
              showCancelButton: true,
              cancelButtonText: "  بستن ",
            });
          }
          else {
            SwalMessage({ title: resp.message, iSsuccess: resp.succeeded, timer: 10000 });
          }
        }
      } catch (error) {
        console.log("error =>", error)
      } finally {
        setRefresh(!refresh);
        setCheckBoxList2([]);
        setLoadingSubmit(false);
      }
    } else {
      SwalMessage({ title: "گروهی انتخاب نشده است", iSsuccess: false });
    }
  }

  const onSubmit = async (data) => {
    data.amusementServiceIds = !_.isUndefined(data.amusementServiceIds)
      ? String(data.amusementServiceIds?.map((item) => item.value))
      : data.amusementServiceIds;
    data.amusementServiceReserveItemIds = !_.isUndefined(data.amusementServiceReserveItemIds)
      ? String(data.amusementServiceReserveItemIds?.map((item) => item.value))
      : data.amusementServiceReserveItemIds;
    data.amusementServiceReserveItemGroupIds = !_.isUndefined(data.amusementServiceReserveItemGroupIds)
      ? String(data.amusementServiceReserveItemGroupIds?.map((item) => item.value))
      : data.amusementServiceReserveItemGroupIds;

    if (data.fromCreatedDate && typeof data.fromCreatedDate === "object") {
      data.fromCreatedDate = tools.DateFormat(data.fromCreatedDate);
    }
    if (data.toCreatedDate && typeof data.toCreatedDate === "object") {
      data.toCreatedDate = tools.DateFormat(data.toCreatedDate);
    }
    if (data.useTimeOf && typeof data.useTimeOf === "object") {
      data.useTimeOf = tools.DateFormat(data.useTimeOf);
    }
    if (data.useTimeTo && typeof data.useTimeTo === "object") {
      data.useTimeTo = tools.DateFormat(data.useTimeTo);
    }

    data.agentId = data.agentId?.value;
    data.promoCategoryType = data.promoCategoryType?.value;
    data.commissionSettlementStatus = data.commissionSettlementStatus?.value;

    tools.setPageNumber(data, searchParams, setValue);

    const apiData = await ApiAgent.getAllUsedPromoCodeByUser(data);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(
      _.omit(data, ["totalPages", "totalCount", "amusmentServiceId"]),
    );
    navigate(`/usedCommissionByAgent?${queryString}`);
    setCheckBoxList2([])
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">کمیسیون های استفاده شده نمایندگان </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm"> گزارش فروش کد تخفیف</span>
          </h3>
          <div className="card-toolbar">
            <Button
              disabled={loadingSubmit}
              variant="success"
              className=" mb-1 mx-1"
              onClick={() => {
                handleGroupEdit(1);
              }}
            >
              <ArrowDownward className="mr-1" />
              {loadingSubmit && <Spinner animation="border" variant="white" size="sm" className="ms-1" />}
              واریز به کیف پول
            </Button>
            <Button
              disabled={loadingSubmit}
              variant="danger"
              className=" mb-1 mx-1"
              onClick={() => {
                handleGroupEdit(2);
              }}
            >
              <ArrowUpward className="mr-1" />
              {loadingSubmit && <Spinner animation="border" variant="white" size="sm" className="ms-1" />}
              برگشت از کیف پول
            </Button>
            <Button
              variant="warning"
              disabled={loadingSubmit}
              style={{ background: "#fda84d", border: "1px solid #fda84d" }}
              className=" mb-1 mx-1"
              onClick={() => {
                handleGroupEdit(3);
              }}
            >
              <CloseIcon className="mr-1" />
              {loadingSubmit && <Spinner animation="border" variant="white" size="sm" className=" ms-1" />}
              عدم واریز به کیف پول
            </Button>
          </div>
        </div>
        {/* Start Box Header */}

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              <div className="border-top pt-3">
                {/* search Advance box */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body >
                      <Card.Body className="pt-0">
                        <Row>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="promoCode"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="کد تخفیف"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || undefined}
                                  onInput={onChange}
                                ></TextField>
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="amusementServiceIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={amusementServiceList?.map((item) => ({ value: item.id, label: item.name }))}
                                  placeholder="تفریح"
                                  className="mt-5"
                                  field={field}
                                  onChange={(e) => inputChangeHandlerService(e)}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="amusementServiceReserveItemGroupIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={group || []}
                                  placeholder="گروه آیتم رزرو "
                                  className="mt-5"
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="amusementServiceReserveItemIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={groupedReserveItemsOptions || []}
                                  placeholder="آیتم رزرو "
                                  className="mt-5"
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>

                        </Row>
                        <Row>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="fromCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  className="mt-5"
                                  placeholder=" از تاریخ "
                                  onChange={(date) => {
                                    var toCreatedDate = getValues("toCreatedDate");
                                    onChange(date);
                                    if (
                                      !toCreatedDate ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(toCreatedDate).getTime())
                                    ) {
                                      setValue("toCreatedDate", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="toCreatedDate"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="تا تاریخ "
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="useTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  placeholder="تاریخ استفاده از"
                                  onChange={(date) => {
                                    var useTimeTo = getValues("useTimeTo");
                                    onChange(date);
                                    if (!useTimeTo || (date?.toDate && date?.toDate()?.getTime() > new Date(useTimeTo).getTime())) {
                                      setValue("useTimeTo", date);
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="useTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={onChange}
                                  placeholder="تاریخ استفاده تا"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="agentId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={agents?.map((item) => ({ value: item.id, label: item.companyName }))}
                                  placeholder="نماینده "
                                  className="mt-5"
                                  field={field}
                                />
                              )}
                            />
                          </Col>

                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="promoCategoryType"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={[
                                    { value: undefined, label: "-------" },
                                    ...promoCategoryTypes?.map((item) => ({ value: item.id, label: item.title })),
                                  ]}
                                  placeholder="نوع کد تخفیف "
                                  className="mt-5"
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="commissionSettlementStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={commissionSettlementStatus}
                                  placeholder="وضعیت کمیسیون نماینده "
                                  className="mt-5"
                                  field={{ ...field, value: field.value ?? "0" }} // مقدار پیش‌فرض روی 0 تنظیم شد
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className="tb-reponsive px-3 mx-auto mt-4">
                            <Button variant="success" type="submit" disabled={isSubmitting} className="mt-3">
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>

                            <Button
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                              className="mt-3 ml-5"
                            >
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                {
                  <DataGridUsedPromoCodeByUser
                    data={listData}
                    setCheckBoxList2={setCheckBoxList2}
                    callBack={callBackJustForRunUseEffect}
                    checkBoxList2={checkBoxList2}
                    setSelectedUsedCommision={setSelectedUsedCommision}
                  />
                }
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
      {
        (!!selectedUsedCommision) &&
        <EditCommisionPrice
          selectedUsedCommision={selectedUsedCommision}
          setSelectedUsedCommision={setSelectedUsedCommision}
        /
        >
      }
    </div>
  );
};

export default Index;
